import React from 'react';
import { IconProps } from '../../../DefaultIcon';

export function CessationsIcon({ className }: IconProps) {
  return (
    <svg
      width="73"
      height="72"
      viewBox="0 0 73 72"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2768)">
        <path
          d="M68.8726 67.5069C67.3222 55.6633 59.8104 45.7172 49.438 40.7441C45.158 43.6451 40.0045 45.3464 34.458 45.3464C28.9115 45.3464 23.7581 43.6451 19.4781 40.7441C9.10565 45.7172 1.57199 55.6633 0.0434272 67.5069C-0.262286 69.9062 1.61567 72.0219 4.03954 72.0219H64.8983C67.3222 72.0219 69.2002 69.9062 68.8945 67.5069H68.8726Z"
          fill="#00416B"
        />
        <path
          d="M53.1506 18.6707C53.1506 28.9876 44.7872 37.3414 34.4584 37.3414C24.1297 37.3414 15.7881 28.9876 15.7881 18.6707C15.7881 8.35383 24.1297 0 34.4584 0C44.7872 0 53.1506 8.35383 53.1506 18.6707Z"
          fill="#00416B"
        />
        <path
          d="M72.1698 67.1141L69.7241 64.6712L64.3304 59.2838L63.2386 58.1932L64.3304 57.1026L69.7241 51.7152L72.1698 49.2723C73.2835 48.1599 73.2835 46.3495 72.1698 45.2371C71.0561 44.1247 69.2437 44.1247 68.13 45.2371L65.6843 47.68L60.2907 53.0675L59.1988 54.1581L58.107 53.0675L52.7133 47.68L50.2676 45.2371C49.1539 44.1247 47.3415 44.1247 46.2278 45.2371C45.1142 46.3495 45.1142 48.1599 46.2278 49.2723L48.6735 51.7152L54.0672 57.1026L55.159 58.1932L54.0672 59.2838L48.6735 64.6712L46.2278 67.1141C45.1142 68.2265 45.1142 70.0369 46.2278 71.1493C47.3415 72.2617 49.1539 72.2617 50.2676 71.1493L52.7133 68.7064L58.107 63.3189L59.1988 62.2283L60.2907 63.3189L65.6843 68.7064L68.13 71.1493C69.2437 72.2617 71.0561 72.2617 72.1698 71.1493C73.2835 70.0369 73.2835 68.2265 72.1698 67.1141Z"
          fill="#D6DCE8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2768">
          <rect width="73" height="72" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
